import { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import axios from 'axios'
import LoadingSpinner from '../../components/common/LoadingSpinner'

export default function CustomerVerificationRedirect() {
  const { token } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const [status, setStatus] = useState('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const verifyCustomerEmail = async () => {
      const params = new URLSearchParams(location.search)
      const websiteId = params.get('websiteId')
      const websiteSlug = params.get('websiteSlug')

      if (!token || !websiteId) {
        setStatus('error')
        setMessage('Missing verification details.')
        return
      }

      try {
        const response = await axios.post(`/customer-auth/verify-email/${token}`, { websiteId })
        const successMessage = response.data.message || 'Verification successful. Your account has been activated.'
        const destination = websiteSlug
          ? `/store/${encodeURIComponent(websiteSlug)}?customerVerificationStatus=success&customerVerificationMessage=${encodeURIComponent(successMessage)}`
          : `/?customerVerificationStatus=success&customerVerificationMessage=${encodeURIComponent(successMessage)}`

        navigate(destination, { replace: true })
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Email verification failed.'
        const destination = websiteSlug
          ? `/store/${encodeURIComponent(websiteSlug)}?customerVerificationStatus=error&customerVerificationMessage=${encodeURIComponent(errorMessage)}`
          : `/?customerVerificationStatus=error&customerVerificationMessage=${encodeURIComponent(errorMessage)}`

        navigate(destination, { replace: true })
      }
    }

    verifyCustomerEmail()
  }, [location.search, navigate, token])

  if (status === 'loading') {
    return <LoadingSpinner />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <h1 className="text-xl font-semibold text-gray-900">Verification status</h1>
        <p className="mt-3 text-sm text-gray-600">{message}</p>
      </div>
    </div>
  )
}
